import React from "react";
import ServiceRoleEditor from "../../roles/ServiceRoleEditor";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import { RoleType } from "../../../../types/types";
import { DraftServiceRole } from "../serviceFormTypes";
interface TeamRolesStepProps {
  roleTypes: RoleType[];
  selectedRoleTypeIds: number[];
  roles: DraftServiceRole[];
  name: string;
  description: string;
  error: string;
  editingId: number | null;
  onRoleTypeToggle: (id: number) => void;
  onNameChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onAdd: () => void;
  onEdit: (role: DraftServiceRole) => void;
  onRemove: (id: number) => void;
}

export function ServiceTeamRolesStep(props: TeamRolesStepProps) {
  return (
    <div className="card">
      <div className="card-title">Team Roles</div>
      <div className="form-help-text" style={{ marginBottom: 8 }}>
        Define the roles needed to staff and deliver this service. A standard
        Service User role is created automatically.
      </div>
      <div className="field-hint" style={{ marginBottom: 12 }}>
        A person can hold more than one role, such as Volunteer and Session
        leader.
      </div>
      <section className="service-role-setup-section">
        <div className="service-role-setup-heading">
          <h3>Suggested roles</h3>
          <span>Select any that apply</span>
        </div>
        {props.roleTypes.length ? (
          <div className="service-role-grid option-group">
            {props.roleTypes.map((role) => (
              <label key={role.roleTypeId} className="option-item">
                <input
                  type="checkbox"
                  checked={props.selectedRoleTypeIds.includes(role.roleTypeId)}
                  onChange={() => props.onRoleTypeToggle(role.roleTypeId)}
                />
                {role.roleName}
              </label>
            ))}
          </div>
        ) : (
          <div className="field-hint" style={{ marginBottom: 0 }}>
            No suggested roles are available.
          </div>
        )}
      </section>
      <section className="service-role-setup-section service-custom-role-section">
        <div className="service-role-setup-heading">
          <div>
            <h3>Service-specific roles</h3>
            <p>Add any other roles this service will need.</p>
          </div>
          <span>
            {props.roles.length} {props.roles.length === 1 ? "role" : "roles"}
          </span>
        </div>
        <ServiceRoleEditor name={props.name} description={props.description}
          onNameChange={props.onNameChange} onDescriptionChange={props.onDescriptionChange}
          onSave={props.onAdd} saveLabel={props.editingId === null ? "Add role" : "Update role"} />
        {props.error && (
          <div className="field-error" role="alert">
            {props.error}
          </div>
        )}
        {props.roles.length ? (
          <div className="service-custom-role-list">
            {props.roles.map((role) => (
              <div key={role.clientId} className="service-custom-role-item">
                <div>
                  <strong>{role.name}</strong>
                  {role.description && <span>{role.description}</span>}
                </div>
                <div className="service-custom-role-actions">
                  <button
                    type="button"
                    className="icon-button service-custom-role-edit"
                    onClick={() => props.onEdit(role)}
                    aria-label={`Edit ${role.name}`}
                    title={`Edit ${role.name}`}
                  >
                    <EditIcon fontSize="small" />
                  </button>
                  <button
                    type="button"
                    className="icon-button service-custom-role-remove"
                    onClick={() => props.onRemove(role.clientId)}
                    aria-label={`Remove ${role.name}`}
                    title={`Remove ${role.name}`}
                  >
                    <DeleteOutlineIcon fontSize="small" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="field-hint service-custom-role-empty">
            No service-specific roles added yet.
          </div>
        )}
      </section>
    </div>
  );
}
